<app-widget [widget-meta]="this.data" hidehelp="true">
    @if (data$ | async; as allRequests) {
        <div>
            <div class="card">
                @if (tab$ | async) {
                }
                <div class="card-header card-header-tabs">
                    <ul class="nav nav-tabs">
                        <li class="nav-item ng-star-inserted">
                            <a class="nav-link" [ngClass]="{'active': currentTab == 'open'}" href="#requestPending" role="tab" data-bs-toggle="tab" aria-controls="requestPending" aria-selected="true" (click)="currentTab='open'">
                                Open
                                @if (!requestService.isFetchingMyRequests) {
                                    <span class="badge badge-primary ml-2">
                                        {{allRequests.support.pendingCount}}
                                    </span>
                                }
                                @else if (!allRequests.support.error) {
                                    <i class="fas fa-circle-notch fa-spin"></i>
                                }
                            </a>
                        </li>
                        <li class="nav-item ng-star-inserted">
                            <a class="nav-link" [ngClass]="{'active': currentTab == 'completed'}" href="#requestCompleted" role="tab" data-bs-toggle="tab" aria-controls="requestCompleted"
                               aria-selected="true" (click)="currentTab='completed'">
                                Completed
                                @if (!requestService.isFetchingMyRequests) {
                                    <span class="badge badge-primary ml-2">
                                        {{allRequests.support.completedCount}}
                                    </span>
                                }
                                @else if (!allRequests.support.error) {
                                    <i class="fas fa-circle-notch fa-spin"></i>
                                }
                            </a>
                        </li>
                        <li class="nav-item ng-star-inserted">
                            <a class="nav-link" [ngClass]="{'active': currentTab == 'purchasing'}" href="#purchasing" role="tab" data-bs-toggle="tab" aria-controls="purchasing" aria-selected="true" (click)="currentTab='purchasing'">
                                Purchasing
                            </a>
                        </li>
                        @if((auth.audience.includes('|Faculty|') || auth.audience.includes('|PhD|'))){
                            <li class="nav-item ng-star-inserted">
                                <a class="nav-link" [ngClass]="{'active': currentTab == 'course recordings'}" href="#courseRecordings" role="tab"
                                   data-bs-toggle="tab" aria-controls="courseRecordings" aria-selected="false" (click)="currentTab='course recordings'">
                                    Course Recordings
                                    @if(profileService.profile$ | async; as profile){
                                        @if((profile.employeeData.FacultyType != '') && (profile.employeeData.FacultyType != 'Unknown')){
                                            @if (!requestService.isFetchingMyRequests) {
                                                <span class="badge badge-primary ml-2">
                                                    {{allRequests.support.classRecordingsCount}}
                                                </span>
                                            }
                                            @else if (!allRequests.support.error) {
                                                <i class="fas fa-circle-notch fa-spin"></i>
                                            }
                                        }
                                    }
                                </a>
                            </li>
                        }
                        @if (auth.hasFeature('Tableau')) {
                            <li class="nav-item ng-star-inserted">
                                <a class="nav-link" [ngClass]="{'active': currentTab == 'tableau'}" href="#tableauRequests" role="tab" data-bs-toggle="tab" aria-controls="tableauRequests" aria-selected="true" (click)="currentTab='tableau'">
                                    Tableau
                                    @if (allRequests.tableau.count > -1) {
                                        <span class="badge badge-primary ml-2">
                                            {{allRequests.tableau.count}}
                                        </span>
                                    }
                                    @if (allRequests.tableau.count==-1 && !allRequests.tableau.error) {
                                        <i class="fas fa-circle-notch fa-spin"></i>
                                    }
                                </a>
                            </li>
                        }
                    </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content mt-3">
                        <!--  OPEN REQUESTS  -->
                        <div class="tab-pane" [ngClass]="{'active': currentTab == 'open'}" id="requestPending" role="tabpanel">
                            <ng-container [ngTemplateOutlet]="requestTemplate"
                                          [ngTemplateOutletContext]="{
                                          requests:allRequests.support.supportRequests.pending,
                                          grouping:'pending',
                                          requestUrl:allRequests.support.requestUrl}">
                            </ng-container>
                            @if (!requestService.isFetchingMyRequests && (allRequests.support.pendingCount > 0 || allRequests.support.completedCount > 0)) {
                                <div class="row g-4 col-12">
                                    <a href="{{allRequests.support.reportUrl}}" target="_blank">
                                        View all {{allRequests.support.pendingCount + allRequests.support.completedCount}} support requests
                                    </a>
                                </div>
                            }
                        </div>
                        <!--  COMPLETED REQUESTS  -->
                        <div class="tab-pane" [ngClass]="{'active': currentTab == 'completed'}" id="requestCompleted" role="tabpanel">
                            @if (!allRequests.support.error) {
                                <ng-container [ngTemplateOutlet]="requestTemplate"
                                              [ngTemplateOutletContext]="{
                                              limit:'3',
                                              requests:allRequests.support.supportRequests.completed,
                                              grouping:'completed',
                                              requestUrl:allRequests.support.requestUrl}">
                                </ng-container>
                                } @else {
                                <ng-template [ngTemplateOutlet]="solarWindsError.template"></ng-template>
                            }
                            @if (!requestService.isFetchingMyRequests && (allRequests.support.pendingCount > 0 || allRequests.support.completedCount > 0)) {
                                <div class="row col-12">
                                    <a href="{{allRequests.support.reportUrl}}" target="_blank">
                                        View all {{allRequests.support.pendingCount + allRequests.support.completedCount}} support requests
                                    </a>
                                </div>
                            }
                        </div>
                        <!--  PURCHASING  -->
                        <div class="tab-pane" [ngClass]="{'active': currentTab == 'purchasing'}" id="purchasing" role="tabpanel" aria-labelledby="purchasing">
                            <msr-purchasing></msr-purchasing>
                        </div>
                        <!--  COURSE RECORDINGS -->
                        @if((auth.audience.includes('|Faculty|') || auth.audience.includes('|PhD|'))){
                            <div class="tab-pane" [ngClass]="{'active':currentTab == 'course recordings'}" id="classRecordings" role="tabpanel" aria-labelledby="classRecordings">
                                <msr-recording-requests [pendingRequests]="allRequests.support.supportRequests.classRecordings" [supportRequests]="allRequests.support"></msr-recording-requests>
                            </div>
                        }
                        <!--  TABLEAU  -->
                        <div class="tab-pane" [ngClass]="{'active':currentTab == 'tableau' && auth.hasFeature('Tableau')}" id="tableauRequests" role="tabpanel" aria-labelledby="tableauRequests">
                            <msr-tableau [data]="allRequests.tableau" [dashboards$]="tableauDashboards.data$"></msr-tableau>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    @else {
        <ng-template [ngTemplateOutlet]="solarWindsError.template"></ng-template>
    }
    
    <loading-or-error #solarWindsError
                      [loadingWrapper]="myRequests"
                      [errorMessage]="'Oops! Looks like we can\'t get information from Solar Winds! There may be a problem with their services.'">
    </loading-or-error>
    
    <ng-template #requestTemplate let-limit='limit' let-requests='requests' let-grouping='grouping' let-requestUrl="requestUrl">
        @if (!requestService.isFetchingMyRequests) {
            @if (requests?.length > 0) {
                <div class="border rounded p-2 mb-3">
                    @for (request of requests | slice:0:limit; track request; let i = $index) {
                        <div class="request">
                            <div class="row">
                                <div class="col-12">
                                    <button type="button" class="btn btn-primary btn-min-size  mx-2 float-end" (click)="isExpanded[request.id] = !isExpanded[request.id]" [attr.aria-expanded]="isExpanded[request.id]" [attr.aria-controls]="'details_'+ request.id">
                                        @if (isExpanded[request.id]) {
                                            <span>Collapse</span>
                                        }
                                        @if (!isExpanded[request.id]) {
                                            <span>Expand</span>
                                        }
                                    </button>
                                    @if (grouping != 'classRecording') {
                                        <span>
                                            <strong>#{{ request.number }}</strong> -
                                            <a href="{{request.href_account_domain}}" target="_blank">
                                                <strong>({{ request.state }})</strong> {{ request.category.name }} - {{ request.subcategory.name }}
                                            </a>
                                        </span>
                                    }
                                </div>
                            </div>
                            <div id="details_{{request.id}}" class="mt-2" [ngbCollapse]="!isExpanded[request.id]">
                                <div class="row col-12">
                                    <div class="col-sm-12 col-md-7" [ngClass]="grouping =='classRecording' ? 'mb-2' : '' ">
                                        @if (grouping=='classRecording') {
                                            <p>{{request.requester.name}} has requested that the following course be recorded:</p>
                                        }
                                        <div [ngClass]="grouping !='classRecording' ? 'incident-description overflow-hidden' : ''"
                                             [innerHTML]="request.description.includes('<img') ? request.description_no_html : request.description"></div>
                                    </div>
                                    <div class="col-sm-12 col-md-5">
                                        <p class="text-end">
                                            <strong>Last Updated: </strong>{{ request.updated_at | date:'MMM d, y' }}
                                        </p>
                                        @if (grouping == 'pending') {
                                            <button id="btnCancelling_{{request.id}}" type="button" class="btn btn-danger ml-2 mr-2 float-end" [disabled]="isCancelling[request.id]" (click)="cancel(request.id)">
                                                Cancel
                                                @if (isCancelling[request.id]) {
                                                    <span><i class="fas fa-circle-notch fa-spin"></i></span>
                                                }
                                            </button>
                                        }
                                    </div>
                                </div>
                                @if (grouping != 'classRecording') {
                                    <div class="row col-12">
                                        <a href="{{request.href_account_domain}}" target="_blank">More details...</a>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
                } @else {
                <div class="border rounded p-2 mb-3">
                    <div class="row">
                        <div class="col-12">
                            <p>You have no {{currentTab}} requests to show.</p>
                            <p>When you submit a ticket or make a service request, your {{currentTab}} requests will show up here where you can check their status and keep track of them.</p>
                        </div>
                    </div>
                </div>
            }
            } @else {
            <ng-template [ngTemplateOutlet]="solarWindsError.template"></ng-template>
        }
    </ng-template>
    @if (cancelRequest | async; as cancellations) {
        <span></span>
    }
</app-widget>
